<template>
  <div>
    <b-tabs v-model="activeTab" pills vertical nav-wrapper-class="w-25">
      <b-tab title="Take Home Pay" active><TabTakeHomePay :data="data" :change="change" :activeTab="activeTab" /></b-tab>
      <b-tab title="Gaji Pokok"><TabGajiPokok :data="data" @change="change = !change" :change="change" :activeTab="activeTab" /></b-tab>
      <b-tab title="Tunjangan"><TabTunjangan :data="data" @change="change = !change" :change="change" :activeTab="activeTab" /></b-tab>
      <b-tab title="Insentif"><TabInsentif :data="data" @change="change = !change" :change="change" :activeTab="activeTab" /></b-tab>
      <b-tab title="Potongan"><TabPotongan :data="data" @change="change = !change" :change="change" :activeTab="activeTab" /></b-tab>
      <b-tab title="Denda"><TabDenda :data="data" @change="change = !change" :change="change" :activeTab="activeTab" /></b-tab>
    </b-tabs>
  </div>
</template>
<script>
import TabGajiPokok from "./gajiPokok/tabGajiPokok";
import TabTunjangan from "./tunjangan/tabTunjangan";
import TabInsentif from "./tunjanganTidakTetap/tabTunjanganTidakTetap";
import TabPotongan from "./potongan/tabPotongan";
import TabTakeHomePay from "./totalGaji/tabTotalGaji";
import TabDenda from "./denda/tabDenda";
export default {
  components: {
    TabGajiPokok,
    TabTunjangan,
    TabInsentif,
    TabTakeHomePay,
    TabPotongan,
    TabDenda,
  },
  props: ["data"],
  data() {
    return {
      change: false,
      activeTab: 0,
    };
  },
  methods: {
    show() {
      // console.log(this.change)
    },
  },
  watch: {
    data: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.change = !this.change;
      }
    },
  },
};
</script>

<style scoped>
.tab-content > .tab-pane {
  padding: 10px 15px;
  /* background-color: whitesmoke; */
  border-radius: 10px;
}
</style>
